import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { editRollingArrangement } from '../../actions/rollingArrangements';
import RollingArrangementForm from '../../components/RollingArrangementForm';
import withPurchaseMethods from '../../decorators/withPurchaseMethods';
import { getSubmitStatus } from '../../reducers';
import rollingArrangementPage from '../../decorators/rollingArrangementPage';

const EditRollingArrangement = ({
  rollingArrangement,
  paymentMethods,
  userId,
  isUserEditPage,
  saveStatus,
  editRollingArrangement,
}) => {
  const prepareInitialValues = () => {
    const { user_profile, arrangement_day, enabled, card_id } =
      rollingArrangement;
    const initialValues = {
      user_profile,
      arrangement_day,
      enabled,
      card_id,
    };
    return initialValues;
  };

  const onSubmit = (values) => {
    return editRollingArrangement(rollingArrangement.id, values);
  };

  return (
    <div>
      <h1>Edit Rolling Arrangement</h1>
      <p className="links">
        {isUserEditPage ? (
          <Link
            className="mb-4"
            to={`/users/${rollingArrangement.user_profile}/rolling-payments`}
          >
            &larr; Back to Arrangement
          </Link>
        ) : (
          <Link
            className="mb-4"
            to={`/rolling-arrangements/${rollingArrangement.id}/view`}
          >
            &larr; Back to Rolling Arrangement
          </Link>
        )}
      </p>
      <RollingArrangementForm
        paymentMethods={paymentMethods}
        saveStatus={saveStatus}
        initialValues={prepareInitialValues()}
        onSubmit={onSubmit}
        btnText="Save Rolling Arrangement"
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  saveStatus: getSubmitStatus(state, 'rollingArrangement'),
});

const mapDispatchToProps = {
  editRollingArrangement,
};

export default compose(
  rollingArrangementPage,
  withPurchaseMethods,
  connect(mapStateToProps, mapDispatchToProps),
)(EditRollingArrangement);
